import script from "./Sprachtechnik-Statistics-Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Statistics-Products.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Statistics-Products.vue?vue&type=style&index=0&id=70025fd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70025fd8"]])

export default __exports__